import { datadogLogs } from '@datadog/browser-logs'

// Safe wrapper for Datadog logging that only executes in browser environment
export const logger = {
  info: (message: string, context?: any) => {
    if (typeof window !== 'undefined') {
      datadogLogs.logger.info(message, context)
    }
  },
  warn: (message: string, context?: any) => {
    if (typeof window !== 'undefined') {
      datadogLogs.logger.warn(message, context)
    }
  },
  error: (message: string, context?: any) => {
    if (typeof window !== 'undefined') {
      datadogLogs.logger.error(message, context)
    }
  },
  debug: (message: string, context?: any) => {
    if (typeof window !== 'undefined') {
      datadogLogs.logger.debug(message, context)
    }
  },
}

// Initialize Datadog browser logs (client-side only). No-op if token absent.
export function initializeDatadog() {
  const clientToken = process.env.REACT_APP_DD_CLIENT_TOKEN

  if (!clientToken) {
    return
  }

  datadogLogs.init({
    clientToken,
    site: 'datadoghq.com',
    service: 'thanx-merchant-ui',
    env: process.env.REACT_APP_DD_ENV || process.env.NODE_ENV || 'development',
    version: process.env.REACT_APP_VERSION,
    forwardErrorsToLogs: false, // Errors stay in Sentry; logs = explicit business events only.
    sessionSampleRate: 100,
  })
}
